<template>
  <AppSelect label="Branch" :items="BRANCHES" />
</template>

<script setup lang="ts">
import { BRANCHES } from '~/assets/constants';
</script>